/**
 * Advisory token estimate for a system prompt. There is no client-side
 * tokenizer (the real count is model-specific and computed server-side), so
 * this is a heuristic for orientation only — the widely-cited ~4 chars/token
 * rule of thumb. Surfaced in the UI as "~N tokens".
 */
export interface PromptStats {
  words: number
  chars: number
  /** Heuristic estimate; never authoritative. */
  tokens: number
}

export function estimatePromptStats(text: string): PromptStats {
  const chars = text.length
  const words = text.trim() ? text.trim().split(/\s+/).length : 0
  return { words, chars, tokens: Math.ceil(chars / 4) }
}
